import React, { useState } from 'react';
import MemberVoting from '../election-management/MemberVoting';
import { getUser } from '../../core/services/auth';
import allowedUsers from './allowedUsers.json';

const MemberVotingPortal = () => {
  const [pin, setPin] = useState('');
  const [userData, setUserData] = useState(null);
  const [userName, setUserName] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [isPinValid, setIsPinValid] = useState(false);
  const [showInvalidMessage, setShowInvalidMessage] = useState(false);

  const handlePinChange = event => {
    const pinInput = event.target.value;
    setPin(pinInput);
    setShowInvalidMessage(false);
    setIsPinValid(pinInput.trim().length > 0);
  };

  const handleFetchUserData = async () => {
    const userEmail = allowedUsers[pin.trim()];
    if (!userEmail) {
      setShowInvalidMessage(true);
    } else {
      setShowInvalidMessage(false);
      try {
        const data = await getUser({ email: userEmail.toLowerCase() });
        setUserData(data);
        setUserName([data.first_name, data.last_name].join(' '));
        setIsModalOpen(false);
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    }
  };

  const buttonStyle = {
    padding: '10px 20px',
    backgroundColor: '#007BFF',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '16px',
    opacity: isPinValid ? 1 : 0.5
  };

  return (
    <div style={containerStyle}>
      {isModalOpen && (
        <div style={modalStyle}>
          <div style={modalContentStyle}>
            <h2 style={modalHeaderStyle}>Enter your PIN</h2>
            <input
              type="password"
              placeholder="Enter your PIN"
              value={pin}
              onChange={handlePinChange}
              style={inputStyle}
            />
            {showInvalidMessage && (
              <p style={{ color: 'red', fontSize: '12px' }}>
                Invalid PIN. This member is not eligible to vote.
              </p>
            )}
            <button
              onClick={handleFetchUserData}
              style={buttonStyle}
              disabled={!isPinValid}
            >
              Submit
            </button>
          </div>
        </div>
      )}
      {userName && <h2 style={welcomeStyle}>Welcome, {userName}!</h2>}
      {userData && <MemberVoting userData={userData} />}
    </div>
  );
};

const containerStyle = {
  padding: '20px',
  fontFamily: 'Arial, sans-serif',
  textAlign: 'center'
};

const modalStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};

const modalContentStyle = {
  backgroundColor: 'white',
  padding: '30px',
  borderRadius: '10px',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  textAlign: 'center',
  width: '300px'
};

const modalHeaderStyle = {
  marginBottom: '20px',
  color: '#007BFF'
};

const inputStyle = {
  marginBottom: '20px',
  padding: '10px',
  width: '100%',
  borderRadius: '5px',
  border: '1px solid #ccc',
  fontSize: '16px'
};

const welcomeStyle = {
  color: '#007BFF',
  marginTop: '20px'
};

export default MemberVotingPortal;
